import {
  Identifiable,
  Project,
  ResourcesListingFilter,
  Role,
  role as roleMock,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import {
  ListedResource,
  ListingPage,
  toListedResource,
  toListingBody,
} from "../utils/resourcesListing";

type Response = {
  _embedded: {
    projectMembers: {
      uuid: string;
      role: { uuid: string; name: string } | null;
      deactivated: boolean | null;
      resource: ListedResource;
    }[];
  };
  page: ListingPage;
};

function getProjectResourcesListing(httpClient: HttpClient) {
  return (project: Identifiable<Project>, filter: ResourcesListingFilter) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: "/projectMembers/listing",
        method: HttpMethods.POST,
        data: { ...toListingBody(filter), projectUuid: project.uuid },
      })
      .then(({ _embedded, page }) => ({
        projectResources: _embedded.projectMembers.map((member) => ({
          uuid: member.uuid,
          project,
          // A material member has no role, like with the details projection.
          role: (member.role
            ? { ...roleMock, uuid: member.role.uuid, name: member.role.name }
            : null) as Identifiable<Role>,
          deactivated: member.deactivated ?? false,
          resource: toListedResource(member.resource),
        })),
        totalPages: page.totalPages || 1,
      }))
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getProjectResourcesListing };
